// @ts-nocheck
import { TABLE_VISIBLE_COLUMNS_CHANGED } from '../types';
import {
    ACCOUNTING_REPORT_COLUMNS,
    BETS_HISTORY_BETLINES_TABLE_COLUMNS,
    BETS_HISTORY_TICKET_TABLE_COLUMNS,
    QUICK_SEARCH_BETLINES_COLUMNS,
    QUICK_SEARCH_TICKET_COLUMNS,
    BETSMONITOR_BETLINES_COLUMNS,
    BETSMONITOR_TICKET_COLUMNS,
    MESSAGES_COLUMNS,
    USERS_COLUMNS,
    SETTLEMENT_BETLINES_COLUMNS,
    SETTLEMENT_TICKETS_COLUMNS,
    COMBINATION_LOCK_TABLE_COLUMNS,
    COMBINATION_LOCK_BETLINES_TABLE_COLUMNS,
    ONLINE_PLAYERS_REPORT_COLUMNS,
    NET_CASH_REPORT_LOGS_TABLE_COLUMNS,
    SPORTS_PERFORMANCE_COLUMNS,
    MONEY_TRANSACTIONS_TABLE_COLUMNS,
    BONUSES_TABLE_COLUMNS,
    BONUS_ENGINE_MONITOR_COLUMNS,
    BONUS_WAGERING_REPORT_COLUMNS,
    PLAYER_BONUS_OFFERS_COLUMNS,
    PROMOTION_BONUS_OFFERS_COLUMNS,
    PLAYER_BONUS_REGULAR_COLUMNS,
    AUDIT_TRAIL_REPORT_COLUMNS,
    MESSAGE_RECIPIENTS_COLUMNS,
    UPDATE_VERSION_TABLE_COLUMNS,
} from '../../utils/constants';
import { transformVisibleColumns } from '../../utils/render';
import {
    ACCOUNTING_PERIOD_RECORD_COLUMNS,
    DECLINED_BETS_HISTORY_COLUMNS,
    DEPOSIT_WITHDRAWAL_COLUMNS,
    GAMING_ACTIVITY_FIRST_GROUP_COLUMNS,
    NET_CASH_REPORT_FIRST_GROUP_COLUMNS,
    PLAYER_SEARCH_COLUMNS,
    REGISTRATIONS_HISTORY_DEFAULT_COLUMNS,
    REGISTRATIONS_HISTORY_PLAYER_COLUMNS,
    TRANSACTION_COLUMNS,
    PLAYER_ACTIVITY_REPORT_COLUMNS,
    TAX_RETURN_REPORT_TABLE_COLUMNS,
    TAX_TURNOVER_REPORT_TABLE_COLUMNS,
    FROZEN_ACCOUNTS_REPORT_COLUMNS,
    INACTIVE_PLAYERS_REPORT_COLUMNS,
    PLAYER_BONUSES_REPORT_COLUMNS,
    PROMOTIONS_COLUMNS,
    MENU_MANAGEMENT_TABLE_COLUMNS,
    TICKET_OPERATIONS_HISTORY_COLUMNS,
} from '../../utils/columns';

const initialState = {
    accountingReport: transformVisibleColumns(ACCOUNTING_REPORT_COLUMNS, true),
    betsHistoryTickets: transformVisibleColumns(BETS_HISTORY_TICKET_TABLE_COLUMNS, true),
    betsHistoryBetLines: transformVisibleColumns(BETS_HISTORY_BETLINES_TABLE_COLUMNS, true),
    gamingActivityFirstGroup: transformVisibleColumns(GAMING_ACTIVITY_FIRST_GROUP_COLUMNS, true),
    quickSearchTickets: transformVisibleColumns(QUICK_SEARCH_TICKET_COLUMNS, true),
    quickSearchBetLines: transformVisibleColumns(QUICK_SEARCH_BETLINES_COLUMNS, true),
    betsMonitorTickets: transformVisibleColumns(BETSMONITOR_TICKET_COLUMNS, true),
    betsMonitorBetLines: transformVisibleColumns(BETSMONITOR_BETLINES_COLUMNS, true),
    messages: transformVisibleColumns(MESSAGES_COLUMNS, true),
    messageRecipients: transformVisibleColumns(MESSAGE_RECIPIENTS_COLUMNS, true),
    users: transformVisibleColumns(USERS_COLUMNS, true),
    settlementTickets: transformVisibleColumns(SETTLEMENT_TICKETS_COLUMNS, true),
    settlementBetLines: transformVisibleColumns(SETTLEMENT_BETLINES_COLUMNS, true),
    transaction: transformVisibleColumns(TRANSACTION_COLUMNS, true),
    accountingPeriodsRecord: transformVisibleColumns(ACCOUNTING_PERIOD_RECORD_COLUMNS, true),
    combinationLock: transformVisibleColumns(COMBINATION_LOCK_TABLE_COLUMNS, true),
    combinationLockBetlines: transformVisibleColumns(COMBINATION_LOCK_BETLINES_TABLE_COLUMNS, true),
    playerSearch: transformVisibleColumns(PLAYER_SEARCH_COLUMNS, true),
    playerActivityReport: transformVisibleColumns(PLAYER_ACTIVITY_REPORT_COLUMNS, true),
    declinedBetsHistory: transformVisibleColumns(DECLINED_BETS_HISTORY_COLUMNS, true),
    deposits: transformVisibleColumns(DEPOSIT_WITHDRAWAL_COLUMNS, true),
    taxOnReturnReport: transformVisibleColumns(TAX_RETURN_REPORT_TABLE_COLUMNS, true),
    taxOnTurnoverReport: transformVisibleColumns(TAX_TURNOVER_REPORT_TABLE_COLUMNS, true),
    onlinePlayersReport: transformVisibleColumns(ONLINE_PLAYERS_REPORT_COLUMNS, true),
    netCashReportFirstGroup: transformVisibleColumns(NET_CASH_REPORT_FIRST_GROUP_COLUMNS, true),
    netCashReportLogs: transformVisibleColumns(NET_CASH_REPORT_LOGS_TABLE_COLUMNS, true),
    frozenAccountsReport: transformVisibleColumns(FROZEN_ACCOUNTS_REPORT_COLUMNS, true),
    registrationsHistoryDefault: transformVisibleColumns(REGISTRATIONS_HISTORY_DEFAULT_COLUMNS, true),
    registrationsHistoryPlayer: transformVisibleColumns(REGISTRATIONS_HISTORY_PLAYER_COLUMNS, true),
    sportsPerformance: transformVisibleColumns(SPORTS_PERFORMANCE_COLUMNS, true),
    moneyTransactions: transformVisibleColumns(MONEY_TRANSACTIONS_TABLE_COLUMNS, true),
    inactivePlayersReport: transformVisibleColumns(INACTIVE_PLAYERS_REPORT_COLUMNS, true),
    bonuses: transformVisibleColumns(BONUSES_TABLE_COLUMNS, true),
    playerBonusesReport: transformVisibleColumns(PLAYER_BONUSES_REPORT_COLUMNS, true),
    playerBonusReport: transformVisibleColumns(PLAYER_BONUSES_REPORT_COLUMNS, true),
    bonusEngineMonitor: transformVisibleColumns(BONUS_ENGINE_MONITOR_COLUMNS, true),
    bonusWageringReport: transformVisibleColumns(BONUS_WAGERING_REPORT_COLUMNS, true),
    bonusOffersReport: transformVisibleColumns(PLAYER_BONUS_OFFERS_COLUMNS, true),
    bonusRegularReport: transformVisibleColumns(PLAYER_BONUS_REGULAR_COLUMNS, true),
    promotions: transformVisibleColumns(PROMOTIONS_COLUMNS, true),
    promotionBonusOffers: transformVisibleColumns(PROMOTION_BONUS_OFFERS_COLUMNS, true),
    auditTrailReport: transformVisibleColumns(AUDIT_TRAIL_REPORT_COLUMNS, true),
    menuManagement: transformVisibleColumns(MENU_MANAGEMENT_TABLE_COLUMNS, true),
    updateVersions: transformVisibleColumns(UPDATE_VERSION_TABLE_COLUMNS, true),
    ticketOperationsHistory: transformVisibleColumns(TICKET_OPERATIONS_HISTORY_COLUMNS, true),
};

const columns = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case TABLE_VISIBLE_COLUMNS_CHANGED: {
            return {
                ...state,
                [payload.key]: payload.columns,
            };
        }
        default:
            return state;
    }
};

export default columns;
